import { render, staticRenderFns } from "./BASchoolsLogoImport.vue?vue&type=template&id=3b68d00c&scoped=true&"
import script from "./BASchoolsLogoImport.vue?vue&type=script&lang=ts&"
export * from "./BASchoolsLogoImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b68d00c",
  null
  
)

export default component.exports